import { register } from '@shopify/theme-sections'
import '../../styles/sections/index-articles.scss'
import $ from 'jquery'

export default register(`index-articles`, {
    onLoad() {
        const slider = document.querySelectorAll(`[data-slick]`)
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload() {
    },
})